import * as React from "react";

function ImageSlashIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 640 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m630.8 469.1-55.95-43.85c.45-3.05.25-6.05.25-9.25l.003-320c0-35.35-28.65-64-64-64H127.1c-13.5 0-26.7 4.98-37.32 13.06L38.81 5.113C28.34-3.058 13.31-1.246 5.109 9.192-3.063 19.63-1.235 34.72 9.187 42.89L601.2 506.9c4.4 3.4 9.6 5.1 13.9 5.1 7.125 0 14.17-3.156 18.91-9.188 9.09-10.412 7.19-25.512-3.21-33.712zM223.1 149.6l-64.29-50.39C164.2 97.15 169.9 96 175.1 96c26.51 0 48 21.49 48 48 0 1.9.3 3.7 0 5.6zm108.1 84.7 23.45-35.18C357.7 194.7 362.7 192 368 192s10.35 2.672 13.31 7.125l103.9 155.9L331.2 234.3zM145.1 416a15.993 15.993 0 0 1-14.26-8.75 16 16 0 0 1 1.334-16.68l70-96C206.1 290.4 210.9 288 216 288s9.916 2.441 12.93 6.574l32.46 44.51 16.43-24.65L63.99 146.8V416c0 35.35 28.65 64 64 64h361.1l-81.66-64H145.1z"
  }));
}

const ForwardRef = React.forwardRef(ImageSlashIcon);
export default ForwardRef;